import { actions }  from "../../actions/common/expertise";

export default function expertise ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case actions.SET_EXPERTISE:
            return setExpertise( newState, action.expertise );
        default: return newState;
    }
}

function setExpertise ( newState, expertise ) {
    newState.expertise = expertise;

    return newState;
}




// WEBPACK FOOTER //
// src/client/reducers/common/expertise.js